<tp-modal #modal>
    <div header>
        <h5 class="modal-title">
            <mat-icon class="ai-title-icon">smart_toy</mat-icon>
            <span [translate]="'tp-cat-ai-extract'" [translateParams]="{ defaultText: 'Analyze with AI' }"></span>
        </h5>
    </div>

    <div body>
        <!-- UPLOAD STEP -->
        <div *ngIf="step === 'upload'" class="ai-upload px-2">
            <p>
                {{'tp-cat-ai-upload-intro' | translate: '{ defaultText : \'Upload your CAT analysis file and we will try to read it even if it does not match any preset schema. XML, CSV, or XLSX files up to 500 KB are supported.\'}'}}
            </p>

            <div class="form-group mt-2">
                <tp-text-box [formControl]="toolHint"
                             placeholder="e.g. Trados, memoQ, Phrase, SmartCat, ..."
                             [label]="'tp-cat-ai-tool-hint' | translate: '{ defaultText : \'Tool (optional)\'}'">
                </tp-text-box>
            </div>

            <div class="form-group mt-2">
                <label>{{'tp-file' | translate: '{ defaultText : "File"}'}}</label>
                <tp-drag-and-drop-file
                    [(files)]="uploadFiles"
                    [autoUpload]="autoUpload"
                    [multiple]="false"
                    [minHeight]="'160px'"
                    (selectedFiles)="onFilesSelected($event)">
                </tp-drag-and-drop-file>
                <div class="py-2">
                    <tp-file-list [(files)]="uploadFiles"></tp-file-list>
                </div>
            </div>

            <div class="ai-privacy-note mt-3">
                <small>
                    <mat-icon class="privacy-icon">info</mat-icon>
                    {{'tp-cat-ai-privacy' | translate: '{ defaultText : \'File contents will be sent to an AI service for analysis. Do not upload confidential client data.\'}'}}
                </small>
            </div>
        </div>

        <!-- PROCESSING STEP -->
        <div *ngIf="step === 'processing'" class="ai-processing text-center py-4">
            <mat-icon class="spin">autorenew</mat-icon>
            <p class="mt-2">
                {{'tp-cat-ai-processing' | translate: '{ defaultText : \'We understand your template — please wait while we process it...\'}'}}
            </p>
        </div>

        <!-- PREVIEW STEP -->
        <div *ngIf="step === 'preview' && extract" class="ai-preview px-2">
            <div class="ai-summary mb-2">
                <div><strong>{{'tp-cat-ai-detected-tool' | translate: '{ defaultText : \'Detected tool\'}'}}:</strong> {{ extract.detectedTool || 'Unknown' }}</div>
                <div><strong>{{'tp-cat-ai-total-words' | translate: '{ defaultText : \'Total words\'}'}}:</strong> {{ extract.totalWords || 0 }}</div>
                <div *ngIf="extract.notes" class="text-muted mt-1"><small>{{ extract.notes }}</small></div>
            </div>

            <table class="table table-sm ai-preview-table">
                <thead>
                    <tr>
                        <th>{{'tp-category' | translate: '{ defaultText : \'Category\'}'}}</th>
                        <th>{{'tp-cat-ai-source' | translate: '{ defaultText : \'Source\'}'}}</th>
                        <th class="text-right">{{'tp-words' | translate: '{ defaultText : \'Words\'}'}}</th>
                        <th class="text-center">{{'tp-cat-ai-confidence' | translate: '{ defaultText : \'Confidence\'}'}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let c of extract.categories">
                        <td>{{ targetFieldLabel(c.targetField) }}</td>
                        <td class="text-muted"><small>{{ c.sourceName }}</small></td>
                        <td class="text-right">{{ c.words }}</td>
                        <td class="text-center">
                            <span class="conf-dot" [ngClass]="confidenceClass(c.confidence)"></span>
                            <small>{{ confidenceLabel(c.confidence) }}</small>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- ERROR STEP -->
        <div *ngIf="step === 'error'" class="ai-error px-2 py-3 text-center">
            <mat-icon class="error-icon">error_outline</mat-icon>
            <p>{{ errorMessage }}</p>
        </div>
    </div>

    <div footer>
        <div class="float-right">
            <tp-button *ngIf="step === 'upload'" class="mr-2" buttonStyle="outline" (buttonClicked)="hide()"
                       [label]="'tp-cancel' | translate: '{ defaultText : \'Cancel\'}'"></tp-button>
            <tp-button *ngIf="step === 'upload'" buttonStyle="submit" (buttonClicked)="analyzeWithAi()"
                       [label]="'tp-cat-ai-analyze' | translate: '{ defaultText : \'Analyze with AI\'}'"></tp-button>

            <tp-button *ngIf="step === 'preview'" class="mr-2" buttonStyle="outline" (buttonClicked)="backToUpload()"
                       [label]="'tp-back' | translate: '{ defaultText : \'Back\'}'"></tp-button>
            <tp-button *ngIf="step === 'preview'" buttonStyle="submit" (buttonClicked)="submitToPipeline()"
                       [label]="'tp-submit-import' | translate: '{ defaultText : \'Submit & Import\'}'"></tp-button>

            <tp-button *ngIf="step === 'error'" class="mr-2" buttonStyle="outline" (buttonClicked)="backToUpload()"
                       [label]="'tp-try-again' | translate: '{ defaultText : \'Try again\'}'"></tp-button>
            <tp-button *ngIf="step === 'error'" buttonStyle="outline" (buttonClicked)="hide()"
                       [label]="'tp-close' | translate: '{ defaultText : \'Close\'}'"></tp-button>
        </div>
    </div>
</tp-modal>
